import React from 'react';
import './App.css';
import { intersectionSpace, line } from './layout';

const Plots = () => {
	return (
		<>
			<div style={{ display: 'flex', flexDirection: 'column', padding: '24px' }}>
				<h1>
					The control-synthesis approach for making expressive and controllable neural music synthesizers -
					Plots
				</h1>

				{line}
			</div>
			<div
				style={{
					display: 'flex',
					flexDirection: 'column',
					padding: '16px',
					justifyContent: 'center',
					margin: 'auto',
				}}
			>
				<h2>Violin</h2>
				{line}
				<div style={{ width: '80%', margin: 'auto', padding: 16 }}>
					Target and predicted intermediate features for 4 seconds of violin not seen during training. The
					darker inner rectangles of the orange boxes represent the MIDI pitches (upper plot) and velocities
					(lower plot). The similarity of predicted and target pitch and loudness contours suggest that the
					MIDI transcriber and control model are performing well on this dataset.
				</div>
				<img
					style={{ width: '80%', margin: 'auto' }}
					src={process.env.PUBLIC_URL + '/violin_prediction.png'}
				></img>

				{intersectionSpace}
				<h2>Flute</h2>
				{line}
				<div style={{ width: '80%', margin: 'auto', padding: 16 }}>
					Target and predicted intermediate features for 4 seconds of flute. The darker inner rectangles of
					the orange boxes represent the MIDI pitches (upper plot) and velocities (lower plot). The
					dissimilarity of predicted and target pitch and loudness contours suggest that the MIDI transcriber
					and/or control model are not performing well on this dataset.
				</div>
				<img
					style={{ width: '80%', margin: 'auto' }}
					src={process.env.PUBLIC_URL + '/flute_prediction.png'}
				></img>
			</div>
		</>
	);
};

export default Plots;
